/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.Programs.VHCB.Title',
    defaultMessage: 'VCHB',
  },
});

export default messages;
